import { render, staticRenderFns } from "./CommunityParticipantCard.vue?vue&type=template&id=306a18b6&scoped=true&"
import script from "./CommunityParticipantCard.vue?vue&type=script&lang=js&"
export * from "./CommunityParticipantCard.vue?vue&type=script&lang=js&"
import style0 from "./CommunityParticipantCard.vue?vue&type=style&index=0&id=306a18b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306a18b6",
  null
  
)

export default component.exports